<template>
  <div class="my-0">
    <!-- Loading -->
    <LoadingSpinner v-if="loading" />

    <!-- Data -->
    <div v-else class="wTimeLine mt-4" >
      <div
          class="d-flex  activityLine border-left ml-4 pt-3"
          v-for="(item, index) in items"
          :key="index"
      >
            <span
                class="text-primary iconline"
                :class="timelineIcon"
                @click="openItem(item.id)"
            ></span>
            <div class="col-12 my-2 px-4">
                <div class="row">
                    <div class="col-6">
                      <span class="h6 font-weight-bold">{{
                          $t(showTitle(item.title))
                      }}</span>
                      <span class="ml-2 h6"
                          ><a class="text-info font-weight-bold" target="_black" :href="link(item.title)">{{
                              $t(showMessage(item.message))
                          }}</a></span
                      >
                    </div>
                    <div class="col-6 d-flex justify-content-end">
                        {{ calculatePeriod(item.created) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
    components: { LoadingSpinner },
    data() {
        return {
          actions:[
          { id:1,
            url:
            { en:"https://help.oliverlist.com/en/knowledge/que-se-passe-t-il-lorsquune-commande-est-modifi%C3%A9e-1",
              fr:"https://help.oliverlist.com/knowledge/que-se-passe-t-il-lorsquune-commande-est-modifi%C3%A9e",
              es:"https://help.oliverlist.com/en/knowledge/que-se-passe-t-il-lorsquune-commande-est-modifi%C3%A9e-1"
            },
            status: "action_order_modified"
          },
          { id:2,
            url:
            { en:"https://help.oliverlist.com/en/knowledge/your-order-has-the-status-in-preparation.-what-does-this-mean",
              fr:"https://help.oliverlist.com/knowledge/votre-commande-a-le-statut-en-pr%C3%A9paration.-quest-ce-que-cela-signifie",
              es:"https://help.oliverlist.com/en/knowledge/your-order-has-the-status-in-preparation.-what-does-this-mean"
            },
            status: "action_order_preparation"
          },
          { id:3,
            url:
            { en:"https://help.oliverlist.com/en/knowledge/is-your-order-stopped-why-and-how-can-you-start-prospecting-again",
              fr:"https://help.oliverlist.com/knowledge/votre-commande-est-en-pause-pourquoi-et-comment-recommencer-%C3%A0-prospecter",
              es:"https://help.oliverlist.com/en/knowledge/is-your-order-stopped-why-and-how-can-you-start-prospecting-again"
            },
            status: "action_order_pause"
          },
          { id:4,
            url:
            { en:"https://help.oliverlist.com/en/knowledge/your-order-has-the-status-draft.-read-more-about-this-activity",
              fr:"https://help.oliverlist.com/knowledge/votre-commande-a-le-statut-brouillon.-quest-ce-que-cela-signifie",
              es:"https://help.oliverlist.com/en/knowledge/your-order-has-the-status-draft.-read-more-about-this-activity"
            },
            status: "action_order_draft"
          },
          { id:5,
            url:
            { en:"https://help.oliverlist.com/en/knowledge/your-order-has-the-status-in-progress.-what-does-this-mean",
              fr:"https://help.oliverlist.com/knowledge/votre-commande-a-le-statut-en-cours.-quest-ce-que-cela-signifie",
              es:"https://help.oliverlist.com/en/knowledge/your-order-has-the-status-in-progress.-what-does-this-mean"
            },
            status: "action_order_running"
          },
          { id:6,
            url:
            { en:"https://help.oliverlist.com/en/knowledge/has-your-order-been-archived-find-out-why-and-how-to-fix-it",
              fr:"https://help.oliverlist.com/knowledge/has-your-order-been-archived-see-why-and-how-to-fix-it",
              es:"https://help.oliverlist.com/en/knowledge/has-your-order-been-archived-find-out-why-and-how-to-fix-it"
            },
            status: "action_order_archived"
          },
          { id:7,
            url:
            { en:"https://help.oliverlist.com/en/knowledge/learn-more-about-the-process-of-creating-oliverlist-prospecting-emails",
              fr:"https://help.oliverlist.com/knowledge/en-apprendre-plus-sur-le-processus-de-cr%C3%A9ation-de-prospection-par-email-doliverlist",
              es:"https://help.oliverlist.com/en/knowledge/learn-more-about-the-process-of-creating-oliverlist-prospecting-emails"
            },
            status: "action_emails_created"
          },
          { id:8,
            url:
            { en:"https://help.oliverlist.com/en/knowledge/email-warmup.-how-does-it-work",
              fr:"https://help.oliverlist.com/knowledge/email-warmup.-comment-cela-fonctionne-t-il",
              es:"https://help.oliverlist.com/en/knowledge/email-warmup.-how-does-it-work"
            },
            status: "action_email_warming_up"
          },
          { id:9,
            url:
            { en:"https://help.oliverlist.com/en/knowledge/the-prospecting-emails-have-completed-the-warm-up-process.-what-happens-next",
              fr:"https://help.oliverlist.com/knowledge/les-emails-de-prospection-ont-termin%C3%A9-le-processus-de-warm-up.-quelle-est-la-suite",
              es:"https://help.oliverlist.com/en/knowledge/the-prospecting-emails-have-completed-the-warm-up-process.-what-happens-next"
            },
            status: "action_email_warmed_up"
          },
          { id:10,
            url: {
              en:"https://help.oliverlist.com/en/knowledge/my-campaigns-have-been-successfully-launched.-what-can-we-expect-now",
              fr:"https://help.oliverlist.com/knowledge/mes-campagnes-ont-%C3%A9t%C3%A9-lanc%C3%A9es-avec-succ%C3%A8s.-%C3%A0-quoi-mattendre-d%C3%A9sormais",
              es:"https://help.oliverlist.com/en/knowledge/my-campaigns-have-been-successfully-launched.-what-can-we-expect-now"
            },
            status: "action_campaigns_launched"
          },
          { id:11,
            url: {
              en:"https://help.oliverlist.com/en/knowledge/you-have-no-more-contacts-available-in-your-order-how-can-you-remedy-this",
              fr:"https://help.oliverlist.com/knowledge/vous-navez-plus-de-contacts-disponibles-dans-votre-commande-comment-pouvez-vous-y-rem%C3%A9dier",
              es:"https://help.oliverlist.com/en/knowledge/you-have-no-more-contacts-available-in-your-order-how-can-you-remedy-this"
            },
            status: "action_less_1000_contact" },
          { id:12,
            url: {
              en:"https://help.oliverlist.com/en/knowledge/you-have-no-more-contacts-available-in-your-order-how-can-you-remedy-this",
              fr:"https://help.oliverlist.com/knowledge/vous-navez-plus-de-contacts-disponibles-dans-votre-commande-comment-pouvez-vous-y-rem%C3%A9dier",
              es:"https://help.oliverlist.com/en/knowledge/you-have-no-more-contacts-available-in-your-order-how-can-you-remedy-this"
            },
            status: "action_less_500_contact" },
          { id:13,
            url: {
              en:"https://help.oliverlist.com/en/knowledge/you-have-no-more-contacts-available-in-your-order-how-can-you-remedy-this",
              fr:"https://help.oliverlist.com/knowledge/vous-navez-plus-de-contacts-disponibles-dans-votre-commande-comment-pouvez-vous-y-rem%C3%A9dier",
              es:"https://help.oliverlist.com/en/knowledge/you-have-no-more-contacts-available-in-your-order-how-can-you-remedy-this"
            },
            status: "action_no_contacts_available" },
          { id:14,
            url: {
              en:"https://help.oliverlist.com/en/knowledge/has-a-users-prospecting-email-been-deleted-find-out-why-and-how-to-fix-it",
              fr:"https://help.oliverlist.com/knowledge/les-courriels-de-prospection-de-votre-repr%C3%A9sentant-ont-ils-%C3%A9t%C3%A9-supprim%C3%A9s-voyez-pourquoi-et-comment-y-rem%C3%A9dier",
              es:"https://help.oliverlist.com/en/knowledge/has-a-users-prospecting-email-been-deleted-find-out-why-and-how-to-fix-it"
            },
            status: "action_order_email_deleted" },
          ]
        };
    },
    props: {
        items: {
            type: Array,
            required: true,
            default: [],
        },
        loading: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        link() {
          return (title) => {
            const actionFound = this.actions.find( el => title.includes(el.status))
            const lang_code = this.$store.state.authentication.user.lang_code

            if(lang_code === 'en') return actionFound.url.en
            if(lang_code === 'fr') return actionFound.url.fr
            if(lang_code === 'es') return actionFound.url.es
          }
        },
        showTitle() {
            return (title) => {
                const titleJson = JSON.parse(title);
                return titleJson.lang_message;
            };
        },
        showMessage() {
            return (message) => {
                const messageJson = JSON.parse(message);
                return messageJson.lang_message;
            };
        },
        calculatePeriod() {
            return (createDate) => {
                const initial = moment(createDate);
                const today = new Date().toLocaleString("en-US", {
                    timeZone: "Europe/Paris",
                });

                //Return Hours
                const qtyHours = Math.abs(initial.diff(today, "hours"));
                if (qtyHours < 24) {
                  if(qtyHours > 1) {
                    return `${qtyHours} ${this.$t('lang.label.hours')}`;
                  } else {
                    return `${qtyHours} ${this.$t('lang.label.hour-ago')}`;
                  }
                }

                //Return Days: only if days is less to 7
                const qtyDays = Math.abs(initial.diff(today, "days"));
                if (qtyDays < 7){
                  if(qtyDays > 1) {
                    return `${qtyDays} ${this.$t('lang.label.days-ago')}`;
                  } else {
                    return `${qtyDays} ${this.$t('lang.label.day-ago')}`;
                  }
                }
                //Return Weeks: only if days is less to 31
                if (qtyDays < 31) {
                  const weeks = (qtyDays / 7).toFixed(0)
                  if(weeks > 1){
                    return ` ${(qtyDays / 7).toFixed(0)} ${this.$t('lang.label.weeks')}`;
                  } else {
                    return ` ${(qtyDays / 7).toFixed(0)} ${this.$t('lang.label.week')}`;
                  }
                }

                //Return Months: only if mounth  is less to 12
                const qtyMonth = Math.abs(initial.diff(today, "months"));
                //console.log('qtyMonth', qtyMonth, initial, today)
                if (qtyMonth < 12)
                    return `${qtyMonth} ${this.$t('lang.label.months')}, ${
                        qtyDays - 30 * qtyMonth
                    } Days`;

                //Return Years
                const qtyYear = Math.abs(initial.diff(today, "years"));
                return `${qtyYear} ${this.$t('lang.label.years')}`;
            };
        },
        timelineIcon(){
          return "icon-check-circle";
        },
    },
};
</script>
  <style>
.wTimeLine ul li.activityLine:first-child .card {
    background: #eaeaea;
    border-color: #eaeaea;
}
.wTimeLine ul li.activityLine:first-child .card .text-muted {
    line-height: 1.2;
    margin-top: 20px;
}
.iconline {
    margin-left: -29px;
    width: 5px;
}
.opportunity .wTimeLine .text-muted.breaknormal {
    white-space: pre-line;
    word-wrap: break-Word;
    line-height: 1.2;
}

.icon-check-circle {
    font-size: 22px;
}
</style>
